const invertedMessages = {
  'Pre-Launch Analysis': 'certs.prelaunch.launch.blocker.title',
  'Launch blocked:': 'certs.prelaunch.launch.blocked.prefix',
  'blocker(s) must be resolved before launching.':
    'certs.prelaunch.launch.blocker.subtitle',
  'Some guardrail checks have warnings. You can still launch, but review the warnings first.':
    'certs.prelaunch.launch.warning.subtitle',
  Continue: 'CERTS_ACTION_CONTINUE',
  Close: 'certs.prelaunch.close.button',
};

export default invertedMessages;
